$(document).ready(function () {

    RecallOperation();

    $(".MyOrders .OrdersContainer .row .items").live("click", function () {
        var ordId = $(this).attr("data-id");
        window.location = '/Orders/Details?ordId=' + ordId;
    });

    $(".CancelItems .CancelRow .itemsContainer .allowRet input").live("change", function () {
        if ($(this).is(":checked")) {
            var id = $(this).attr("id").split("-")[1];
            $("#RetItem_" + id + "__RetReason").attr("disabled", false);
            // Seçilen ürünün iade nedeni combobox'ını işaretler
            $("#RetItem_" + id + "__RetReason").addClass("SelectedItem");

            // Ürün seçilirse butonu aktif yap
            $(".RetOrder .CancelItems .RetOrderBtn").attr("disabled", false);
        } else {
            var id = $(this).attr("id").split("-")[1];
            $("#RetItem_" + id + "__RetReason").attr("disabled", "disabled");
            $("#RetItem_" + id + "__RetReason").removeClass("SelectedItem");
            $("#RetItem_" + id + "__RetReason").siblings(".warningMessage").addClass("hide");
            $("#RetItem_" + id + "__RetReason").css("border", "1px solid #ccc");


        }
        if ($(".CancelItems .CancelRow .itemsContainer .allowRet input").is(":checked") == false) {
            //Seçili hiçbir ürün yoksa butonu pasif yap
            $(".RetOrder .CancelItems .RetOrderBtn").attr("disabled", "disabled");
        }
    });

    // Eğere borderı model validasyonundan kırmızı olduysa eski haline getir
    $(".CancelItems .CancelRow .itemsContainer select").live("change", function () {
        $(this).css("border", "1px solid #ccc");
        $(this).siblings(".warningMessage").addClass("hide");
    });

    $("form.RetOrderForm").die("submit").live("submit", function () {
        var isSelectItemValid = true;
        // Seçilmiş ürünlerin iade nedeni comboboxların kontrolü
        // Eğer herhangi biri seçilmediyse hata dön
        var SelectedItems = document.querySelectorAll(".SelectedItem");
        [].forEach.call(SelectedItems, function (e) {
            if (e.value == "" || e.value == undefined || e.value == null) {
                isSelectItemValid = false;
                e.style.border = "1px solid red";
                e.nextElementSibling.classList.remove("hide");
            }
        })

        if (isSelectItemValid == true) {
            $form = $(this);
            $(".AjaxLoader").show();
            $(".AjaxLoader").css("display", "block");
            $.ajax({
                type: "POST",
                url: $form.attr("action"),
                data: $form.serialize(),
                dataType: "json",
                beforeSend: function () {
                    $('form.RetOrderForm input[type="submit"]').addClass('hide');
                    $('form.RetOrderForm span.bekleyinizSpani').removeClass('hide');
                },
                success: function (dt) {
                    $(".AjaxLoader").hide();

                    $('form.RetOrderForm input[type="submit"]').removeClass('hide');
                    $('form.RetOrderForm span.bekleyinizSpani').addClass('hide');

                    if (dt.Sonuc === true) {

                        $form.hide();
                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").removeClass("alert-error");
                        $("#AlertResult").html(dt.IslemSonucAciklama);
                        //.animate({
                        //    opacity: 0,
                        //}, 10000, function () {
                        //});

                        //setTimeout(function () {
                        //    document.location = "/";
                        //}, 5000);
                        //$(".RetTypeHome").css("display", "inline-block");
                    }
                    else {
                        $(".AjaxLoader").hide();

                        $("#AlertResult").addClass("alert alert-danger");
                        $("#AlertResult").show();
                        $("#AlertResult").addClass("alert alert-error").html(dt.IslemSonucAciklama);
                    }

                },
                error: function () {
                    $(".AjaxLoader").hide();

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            });

        }
        else {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        }

        return false;
    });

    $(".MoneyTransferForm #Amount").live('keyup', function (e) {

        var moneytansferAmount = $(this).val();

        var replacedVal = moneytansferAmount.replace(",", "");
        replacedVal = replacedVal.replace(",", "");
        replacedVal = replacedVal.replace(".", "");
        replacedVal = replacedVal.replace(".", "");

        if (!isNumeric(replacedVal)) {
            $(".MoneyTransferForm #Amount").val("");
        }
        else {


            var newVal = moneytansferAmount.replace(",", ".");
            newVal = newVal.replace(",", ".");

            $(".MoneyTransferForm #Amount").val(newVal);

        }

    });

    $("form.MoneyTransferForm").live("submit", function () {

        $form = $("form.MoneyTransferForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc === true) {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);

                    $form.find("table").hide();

                    $("#MoneyTransferResult").removeClass("alert-error");
                    $("#MoneyTransferResult").addClass("alert alert-success").show();

                }
                else {

                    $("#MoneyTransferResult").html(dta.IslemSonucAciklama);
                    $("#MoneyTransferResult").addClass("alert alert-error").show();
                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        return false;
    });

    //$(".RetOrderItem .allowRetContainer .AllowRet .customCheck").live("click", function () {
    //    alert("aaa");
    //    if ($(this).prop("checked")) {
    //        $(".RememberCheck .customCheck").addClass("checked");
    //        $("#AllowRet").val(true);
    //    } else {
    //        $(".RememberCheck .customCheck").removeClass("checked");
    //        $("#AllowRet").val(false);
    //    }
    //});

    //$('.CancelRow select.RetType').live("change", function () {
    //    var value = $(this).val();
    //    $selectedRetTypeThis = $(this);
    //    if (value == "0") {
    //        $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
    //    } else if (value == "1" || value == "2") {
    //        /*$(".CancelRow .RetReason").css("display", "");*/

    //        $.ajax({
    //            type: "POST",
    //            url: "/Orders/RetOrderType",
    //            data: "RetType=" + value,
    //            dataType: 'json',
    //            success: function (dta) {
    //                dta.JsonRs = JSON.parse(dta.JsonRs);
    //                $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").html("");
    //                for (var i = 0; i < dta.JsonRs.length; i++) {
    //                    $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").append(new Option(dta.JsonRs[i].Text, dta.JsonRs[i].Value));
    //                }
    //                $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "block");

    //            },
    //            error: function () {

    //                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
    //            }

    //        });

    //    } else {
    //        $selectedRetTypeThis.parents(".CancelRow").find(".RetReason").css("display", "none");
    //    }

    //    var slc = $(this);
    //    var oid = slc.attr("dataid");
    //    var ind = slc.attr("dataind");
    //    var kacitem = parseInt($(".CancelRow select.RetType").length);
    //    if (kacitem <= 0) return;
    //    var itemsay = 0;

    //    var iaTutar = 0;
    //    var siptutar = parseFloat($("#TotalRetOrderAmount").attr("dataAmount").replace(",", "."));
    //    $selectedRetTypeThis.each(function () {
    //        if ($(this).val() === "2" || $(this).val() === "4") {
    //            itemsay = parseInt(itemsay) + 1;
    //            iaTutar += parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));
    //        }
    //    });

    //    if (kacitem === itemsay) {
    //        iaTutar = siptutar;
    //    }
    //    if (itemsay > 0) {
    //        $(".iadedivi").removeClass("hide");
    //    }
    //    else {
    //        $(".iadedivi").addClass("hide");
    //    }
    //    if (slc.val() === "1" || slc.val() === "3") { //değişim yapmak istiyorum
    //        $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").removeClass("hide");
    //    }
    //    else {
    //        $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").addClass("hide");
    //    }

    //    $("#RetTotalAmount").html(iaTutar);
    //    $("#OrderAmountAfterRet").html((siptutar - iaTutar).toFixed(2));
    //    //if (slc.val() == "2") { // ücret iadesi istiyorum          
    //    //}
    //    //else {
    //    //    $("#RetTotalAmount").html(parseFloat($("#RetTotalAmount").html()) - iaTutar);
    //    //    $("#OrderAmountAfterRet").html(parseFloat($("#OrderAmountAfterRet").html()) + iaTutar);
    //    //}

    //});


    $('.changePassCancel').click(function () {
        $('.ChangePassForm input').val('');

    });

    $("a.MyOldOrdersBtn").click(function () {

        $(".MyOldOrders").show();
    });

    $(".deliveryeditmode a").live("click", function () {
        $(".ConfirmDeliveryEdits").show();
        $(".OrderDeliveryAdresEdit").show();
        $(".deliveryeditmode").hide();
        $(".OrderDeliveryAdres").hide();
    });

    $(".billingeditmode a").live("click", function () {
        $(".ConfirmBillingEdits").show();
        $(".OrderBillingAdresEdit").show();
        $(".billingeditmode").hide();
        $(".OrderBillingAdres").hide();
    });

    $(".ConfirmDeliveryEdits a.cancel").live("click", function () {

        $(".ConfirmDeliveryEdits").hide();
        $(".OrderDeliveryAdresEdit").hide();
        $(".deliveryeditmode").show();
        $(".OrderDeliveryAdres").show();
    });

    $(".ConfirmBillingEdits a.cancel").live("click", function () {
        $(".ConfirmBillingEdits").hide();
        $(".OrderBillingAdresEdit").hide();
        $(".billingeditmode").show();
        $(".OrderBillingAdres").show();
    });

    $(".ConfirmDeliveryEdits a.confirm").live("click", function () {

        var params = "oID=" + $("#oID").val() + "&DeliveryAdressDetail=" + $("#DeliveryAdressDetail").val() + "&EditdCity=" + $("#EditdCity").val() + "&EditdTown=" + $("#EditdTown").val() + "&DeliveryAdressPhone=" + $("#DeliveryAdressPhone").val() + "&DeliveryAdressPhone2=" + $("#DeliveryAdressPhone2").val();
        $.ajax({
            type: "GET",
            url: "/Orders/ChangeDeliveryAddressInOrder",
            data: params,
            cache: false,
            async: false,
            success: function (data) {

                if (data != null) {

                    $(".OrderDeliveryAdres").html(data);

                    $(".ConfirmDeliveryEdits").hide();
                    $(".OrderDeliveryAdresEdit").hide();
                    $(".deliveryeditmode").show();
                    $(".OrderDeliveryAdres").show();

                }
                else {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz....!');
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
    });

    $(".ConfirmBillingEdits a.confirm").live("click", function () {

        var params = "oID=" + $("#oID").val() + "&BillingAdressDetail=" + $("#BillingAdressDetail").val() + "&EditbCity=" + $("#EditbCity").val() + "&EditbTown=" + $("#EditbTown").val() + "&BillingAdressPhone=" + $("#BillingAdressPhone").val() + "&BillingAdressPhone2=" + $("#BillingAdressPhone2").val();
        $.ajax({
            type: "GET",
            url: "/Orders/ChangeBillingAddressInOrder",
            data: params,
            cache: false,
            async: false,
            success: function (data) {

                if (data != null) {

                    $(".OrderBillingAdres").html(data);

                    $(".ConfirmBillingEdits").hide();
                    $(".OrderBillingAdresEdit").hide();
                    $(".billingeditmode").show();
                    $(".OrderBillingAdres").show();

                }
                else {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz....!');
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
    });

    $(".ddl_dcity").live("change", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();
        $.ajax({
            type: 'get',
            url: '/Orders/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#EditdTown option').remove();

                $('#EditdTown')
                    .append($("<option></option>")
                        .attr("value", "0")
                        .text("Lütfen Seçin"));

                for (var i = 0; i < dt.length; i++) {
                    $('#EditdTown').append(new Option(dt[i].Name, dt[i].ID));

                }

                $(".ajaxilce").hide();
            }
        });


    });

    $(".ddl_bcity").live("change", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/Orders/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#EditbTown option').remove();

                $('#EditbTown')
                    .append($("<option></option>")
                        .attr("value", "0")
                        .text("Lütfen Seçin"));

                for (var i = 0; i < dt.length; i++) {
                    $('#EditbTown').append(new Option(dt[i].Name, dt[i].ID));

                }

                $(".ajaxilce").hide();


            }
        });


    });
});


// iade işlemleri
function RecallOperation() {

    $("#returnPolicyModal .close").live("click", function () {
        $("#returnPolicyModal").addClass("fade");
        $("#returnPolicyModal").removeClass("show");
    });

    $("#newCargoCode").live("click", function () {
        var id = $(this).attr("data-id");
        $(".AjaxLoader").show();
        $(".AjaxLoader").css("display", "block");
        $.ajax({
            type: "POST",
            url: "/Orders/GetNewCargoCode",
            data: "RetMessageID=" + id,
            cache: false,
            success: function (data) {
                if (data.Sonuc == true) {
                    $(".AjaxLoader").hide();
                    $(".RetItems .alertContent").removeClass("hide");
                    $(".RetItems .alertContent").html("Yeni kargo kodunuz:" + data.Deger5);

                    $(".RetItems .cargoDetailArea .retCargoCode span").html("İade Kargo Kodunuz :" + data.Deger5);

                }
                else {
                    $(".AjaxLoader").hide();
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
    });
};
